module.exports = __webpack_public_path__ + "img/registration.dbbd5c23.gif";